export default __webpack_public_path__ + "static/media/bastian.f84b43a1.jpeg";